import {
  i
} from "./chunk.775UL347.js";

// src/components/icons/jb-language-icon/jb-language-icon.css.ts
var jb_language_icon_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}path{fill:var(--stroke-color, #141e55)}@media(forced-colors: active){path{fill:CanvasText}}`;

export {
  jb_language_icon_css_default
};
